import { render, staticRenderFns } from "./Aggregator.vue?vue&type=template&id=b511b7be"
import script from "./Aggregator.vue?vue&type=script&lang=js"
export * from "./Aggregator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports